"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVeryLegacyEventrDate = isVeryLegacyEventrDate;
exports.isLegacyEventrDate = isLegacyEventrDate;
exports.isEventrDate = isEventrDate;
exports.isIsoUTCDate = isIsoUTCDate;
exports.isDefaultUnzonedDatetimeDash = isDefaultUnzonedDatetimeDash;
exports.isDefaultUnzonedDatetimeSlash = isDefaultUnzonedDatetimeSlash;
exports.isShortDate = isShortDate;
exports.isTimeString = isTimeString;
function isVeryLegacyEventrDate(date) {
    const regexp = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?)$/;
    const isMatch = regexp.test(date);
    if (isMatch) {
        const isValid = !isNaN(new Date(date).getTime());
        return isValid;
    }
    else {
        return isMatch;
    }
}
function isLegacyEventrDate(date) {
    const regexp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?[+-]\d{2}:\d{2}[NO]$/; // e.g. 2022-01-01T00:00-04:00N
    const isMatch = regexp.test(date);
    if (isMatch) {
        const isValid = !isNaN(new Date(date.slice(0, -1)).getTime());
        return isValid;
    }
    else {
        return isMatch;
    }
}
/// yyyy-mm-ddThh:mmN123
function isEventrDate(date) {
    const regexp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}[NO]\d{0,3}$/;
    const isMatch = regexp.test(date);
    if (isMatch) {
        const isValid = !isNaN(new Date(date.slice(0, 16)).getTime());
        return isValid;
    }
    else {
        return isMatch;
    }
}
function isIsoUTCDate(date) {
    const regexp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/; // e.g. 2022-01-01T00:00:00Z or 2022-01-01T00:00:00.000Z
    const isMatch = regexp.test(date);
    if (isMatch) {
        const isValid = !isNaN(new Date(date).getTime());
        return isValid;
    }
    else {
        return isMatch;
    }
}
function isDefaultUnzonedDatetimeDash(date) {
    const regexpDash = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
    const isMatch = regexpDash.test(date);
    if (isMatch) {
        const isValid = !isNaN(new Date(date.replace(' ', 'T')).getTime());
        return isValid;
    }
    else {
        return isMatch;
    }
}
function isDefaultUnzonedDatetimeSlash(date) {
    const regexpSlash = /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}$/;
    const isMatch = regexpSlash.test(date);
    return isMatch;
}
function isShortDate(date) {
    const regexp = /^(?:(?:\d{4}[-/]\d{2}[-/]\d{2})|(?:\d{2}[-/]\d{2}[-/]\d{4}))$/; // e.g. 2022/01/01 or 2022-01-01 or 01/01/2022 or 01-01-2022
    const isMatch = regexp.test(date);
    if (isMatch) {
        const isValid = !isNaN(new Date(date).getTime());
        return isValid;
    }
    else {
        return isMatch;
    }
}
function isTimeString(date) {
    const regexp = /^(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d{1,3})?)?$/; // e.g. 23:59 or 23:59:59 or 23:59:59.999
    const isValid = regexp.test(date);
    return isValid;
}
